import {
  BuildingEnergyRatingType,
  ContentStateInterface,
  EnergyCertificateCreationDate,
} from '../../../../@types/types'
import { EnergyCertificateAvailability } from '../../../../@types/radio-types'
import { DefaultRentPriceTypeOption } from '../../../../@types/dropdown-types'

//TODO: There is a possible race condition between doReset and onChange handlers for energyCertificate,
// K
export function resetEnergyCertificateIfNotAvailable(newInsertionData: ContentStateInterface) {
  if (
    newInsertionData.energyCertificateAvailability !== EnergyCertificateAvailability.AVAILABLE ||
    newInsertionData.energyCertificateCreationDate === EnergyCertificateCreationDate.TILL_30_04_2014
  ) {
    newInsertionData.energyCertificateCreationDate = undefined
    newInsertionData.buildingEnergyRatingType = undefined
    newInsertionData.efficiencyClass = undefined
    newInsertionData.thermalCharacteristic = undefined
    newInsertionData.consumptionContainsWarmWater = undefined
    newInsertionData.legalConstructionYear = undefined
    newInsertionData.energyCertificateAvailability =
      newInsertionData.energyCertificateAvailability === EnergyCertificateAvailability.AVAILABLE
        ? undefined
        : newInsertionData.energyCertificateAvailability
  }

  return newInsertionData
}

export function resetConstructionYearIfUnknown(newInsertionData: ContentStateInterface) {
  if (newInsertionData.unknownConstructionYear) {
    newInsertionData.constructionYear = undefined
  }
  return newInsertionData
}

export function resetConsumptionContainsWarmWaterIfNecessary(
  insertionData: ContentStateInterface,
  isNationalAddress: boolean
) {
  if (insertionData.buildingEnergyRatingType !== BuildingEnergyRatingType.ENERGY_CONSUMPTION || isNationalAddress) {
    insertionData.consumptionContainsWarmWater = false
  }
}

export function resetPriceIfNecessary(insertionData: ContentStateInterface) {
  if (insertionData.priceType?.value === DefaultRentPriceTypeOption.REQUEST_RENT_PRICE) {
    insertionData.price = undefined
  }
}
